module.exports = __webpack_public_path__ + "img/img02.0fd54272.png";